export class BarcodeBlockDetails {
    public value: string;
    public barcode_type: string;
    public textPosition: string;
    public width: number;
    public height: number;
    public justification: string;
    public textLines?: string[];
    public textFormatting?: string[]; 
    public align?: number;
    public fontType?: number;
    public fontSize?: number;
    public imagePath?: string;

    constructor(
        value: string, 
        barcode_type: string, 
        textPosition: string, 
        width: number, 
        height: number, 
        justification: string, 
    ) {
        this.value = value;
        this.barcode_type = barcode_type;
        this.textPosition = textPosition;
        this.width = width;
        this.height = height;
        this.justification = justification;
    }
}